<template>
  <div
    id="order-care-bar-chart"
    :style="{ width: '100%' }"
    class="chartheight"
  ></div>
</template>

<script>
export default {
  props: {
    year: null,
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    //绘制柱状图
    drawOrderCareBar() {
      let orderCareBarChart = this.$echarts.init(
        document.getElementById("order-care-bar-chart"),
        "light"
      ); //初始化echats实例
      var dataReset = [
        { value: this.year.under15Count },
        { value: this.year.between16_25Count, itemStyle:{color: '#7f86ea'} },
        { value: this.year.between26_35Count, itemStyle:{color: '#7f86ea'} },
        { value: this.year.between36_45Count, itemStyle:{color: '#7f86ea'} },
        { value: this.year.between46_55Count, itemStyle:{color: '#7f86ea'} },
        { value: this.year.above56Count, itemStyle:{color: '#7f86ea'} },
        { value: this.year.unknownAgeCount, itemStyle:{color: '#7f86ea'} },
      ];
      var datasetReset = [
        "15岁以下",
        "16-25岁",
        "26-35岁",
        "36-45岁",
        "46-55岁",
        "56岁以上",
        "未识别",
      ];
      orderCareBarChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} 人",
        },
        xAxis: {
          type: "category",
          data: datasetReset,
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 10,
          bottom: 0,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  // show: true, //开启显示
                  // position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666666",
                    fontSize: 14,
                  },
                },
                color: function (params) {
                  var colorList = [
                    "#5882FB",
                    "#5882FB",
                    "#5882FB",
                    "#5882FB",
                    "#5882FB",
                    "#5882FB",
                    "#5882FB",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            data: dataReset,
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChart.resize();
      };
    },
  },
};
</script>


<style scoped lang="scss">
.chartheight{
      height: 300px ;
            @media screen and (max-width: 1400px){
              margin-top: 10px;
          height: 250px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 10px;
          height: 230px;
        }
}
</style>